import axios from 'axios';
import React from 'react';
import Select from 'react-select/async';
import PropTypes from 'prop-types';

class DataValueSelector extends React.Component
{
  constructor(props) {
    super(props);

    this.state = {
      options: [],
    };

    this.search = this.search.bind(this);
  }
  componentDidMount() {
    axios.get(`/api/product-data/data-groups/${this.props.dataGroupSlug}/values`)
      .then((response) => {
        this.setState({
          options: response.data.data.map(value => ({ label: value.name, value: value.id })),
        });
      });
  }
  search(text, callback) {
    axios.get(`/api/product-data/data-groups/${this.props.dataGroupSlug}/values?search=${text}`)
      .then((response) => {
        callback(response.data.data.map(value => ({ label: value.name, value: value.id })));
      });
  }
  render() {
    return (
      <div>
        <Select defaultOptions={this.state.options} loadOptions={this.search} />
      </div>
    );
  }
}

DataValueSelector.propTypes = {
  dataGroupSlug: PropTypes.string.isRequired,
};

export default DataValueSelector;
